import { useEffect, useState } from 'react';

function useCountdown(targetDate: Date) {
  const calc = () => {
    const diff = targetDate.getTime() - Date.now();
    if (diff <= 0) return { days: 0, hours: 0, minutes: 0, seconds: 0 };
    return {
      days: Math.floor(diff / (1000 * 60 * 60 * 24)),
      hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((diff / (1000 * 60)) % 60),
      seconds: Math.floor((diff / 1000) % 60),
    };
  };
  const [time, setTime] = useState(calc);
  useEffect(() => {
    const id = setInterval(() => setTime(calc()), 1000);
    return () => clearInterval(id);
  }, []);
  return time;
}

export default function KeikoanaguchisecretLIVE20260323Page() {
  const LINE_URL = 'https://liff.line.me/2006804245-oakZeLjM/landing?follow=%40954vrmxf&lp=siUB52&liff_id=2006804245-oakZeLjM';
  const liveDate = new Date('2026-03-23T21:00:00+09:00');
  const { days, hours, minutes, seconds } = useCountdown(liveDate);

  useEffect(() => {
    let metaRobots = document.querySelector('meta[name="robots"]') as HTMLMetaElement | null;
    if (!metaRobots) {
      metaRobots = document.createElement('meta');
      metaRobots.name = 'robots';
      document.head.appendChild(metaRobots);
    }
    metaRobots.content = 'noindex, nofollow';
    return () => {
      if (metaRobots) metaRobots.content = 'index, follow';
    };
  }, []);

  const pad = (n: number) => String(n).padStart(2, '0');

  return (
    <div className="min-h-screen relative overflow-hidden" style={{ background: '#fdfcf8', fontFamily: "'Noto Serif JP', serif" }}>

      {/* ── 背景装飾 ── */}
      <div className="fixed inset-0 pointer-events-none overflow-hidden" style={{ zIndex: 0 }}>
        {/* 上部光 */}
        <div className="absolute -top-40 left-1/2 -translate-x-1/2 w-[700px] h-[700px] rounded-full"
          style={{ background: 'radial-gradient(ellipse, rgba(212,175,55,0.07) 0%, transparent 70%)' }} />
        {/* 下部光 */}
        <div className="absolute -bottom-40 left-1/2 -translate-x-1/2 w-[600px] h-[600px] rounded-full"
          style={{ background: 'radial-gradient(ellipse, rgba(212,175,55,0.05) 0%, transparent 70%)' }} />
        {/* 星 */}
        {[...Array(36)].map((_, i) => {
          const ls = [4,9,15,21,28,34,40,46,52,58,63,69,75,81,88,93,6,12,18,24,31,37,43,49,56,62,68,74,80,86,92,97,2,11,22,77];
          const ts = [3,8,14,19,26,32,38,44,50,56,62,68,74,80,86,92,5,11,17,23,30,36,42,48,54,61,67,73,79,85,91,96,7,16,27,83];
          const d = [0,0.4,0.8,1.2,1.6,2,2.4,2.8,3.2,3.6,0.2,0.6,1,1.4,1.8,2.2,2.6,3,3.4,3.8,0.1,0.5,0.9,1.3,1.7,2.1,2.5,2.9,3.3,3.7,0.3,0.7,1.1,1.5,1.9,2.3];
          return (
            <div key={i} className="absolute rounded-full" style={{
              width: '1.5px', height: '1.5px',
              left: `${ls[i]}%`, top: `${ts[i]}%`,
              background: 'rgba(212,175,55,0.5)',
              animation: `starTwinkle ${2.5 + (i % 4) * 0.5}s ease-in-out infinite`,
              animationDelay: `${d[i]}s`,
            }} />
          );
        })}
      </div>

      {/* ── ヘッダー細線 ── */}
      <div className="w-full h-px" style={{ background: 'linear-gradient(90deg, transparent, rgba(212,175,55,0.5), transparent)' }} />

      {/* ── メインコンテンツ ── */}
      <div className="relative z-10 w-full max-w-lg mx-auto px-6 py-12 flex flex-col items-center">

        {/* ── セクション① ファーストビュー ── */}
        <section className="text-center mb-14 w-full">
          <h1 className="text-2xl font-semibold mb-6 leading-relaxed" style={{ color: '#2c2416', letterSpacing: '0.1em' }}>
            まだ閉じないで！
          </h1>

          {/* 重要テキスト */}
          <div className="rounded-xl px-6 py-5 mb-2 w-full" style={{
            background: 'linear-gradient(135deg, rgba(212,175,55,0.08), rgba(212,175,55,0.04))',
            border: '1px solid rgba(212,175,55,0.35)',
          }}>
            <p className="text-sm font-semibold mb-2" style={{ color: '#d4af37', letterSpacing: '0.12em' }}>※ 重要 ※</p>
            <p className="text-sm leading-relaxed" style={{ color: '#4a3a28', letterSpacing: '0.06em' }}>
              LIVEの参加URL（ZOOM）は<br />
              <strong>LINEからのみ</strong>お送りします
            </p>
          </div>
        </section>

        {/* ── カウントダウン前CTA ── */}
        <section className="w-full mb-10">
          <a
            href={LINE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="w-full flex items-center justify-center gap-3 py-5 rounded-2xl font-bold text-base cursor-pointer whitespace-nowrap transition-all active:scale-95"
            style={{
              background: 'linear-gradient(135deg, #06C755 0%, #00a846 100%)',
              color: '#ffffff',
              letterSpacing: '0.1em',
              fontSize: '16px',
              boxShadow: '0 6px 30px rgba(6,199,85,0.3)',
              textDecoration: 'none',
            }}
          >
            <i className="ri-line-fill text-2xl" />
            LINEで参加URLを受け取る
          </a>
          <div className="flex flex-col items-center gap-1 mt-4">
            <p className="text-xs" style={{ color: '#9a8060', letterSpacing: '0.08em' }}>※30秒で登録完了します</p>
            <p className="text-xs font-semibold" style={{ color: '#c0392b', letterSpacing: '0.08em' }}>※LINE登録しないと参加できません</p>
          </div>
        </section>

        {/* ── カウントダウン ── */}
        <section className="w-full mb-14">
          <div className="flex items-center justify-center gap-3">
            {[
              { label: '日', value: pad(days) },
              { label: '時間', value: pad(hours) },
              { label: '分', value: pad(minutes) },
              { label: '秒', value: pad(seconds) },
            ].map((item, i) => (
              <div key={i} className="flex flex-col items-center">
                <div className="w-16 h-16 rounded-xl flex items-center justify-center" style={{
                  background: 'linear-gradient(135deg, #2c2416, #3d3020)',
                  border: '1px solid rgba(212,175,55,0.4)',
                }}>
                  <span className="text-2xl font-bold" style={{ color: '#d4af37', fontFamily: 'Georgia, serif', letterSpacing: '0.05em' }}>{item.value}</span>
                </div>
                <span className="text-xs mt-1.5" style={{ color: '#9a8060', letterSpacing: '0.1em' }}>{item.label}</span>
              </div>
            ))}
          </div>
        </section>

        {/* ── セクション② ストーリー ── */}
        <section className="text-center mb-14 w-full">
          <p className="text-base leading-[2.2] whitespace-pre-line" style={{ color: '#4a3a28', letterSpacing: '0.08em' }}>
            {`今回のLIVEは\nフランス・モナコからニースへ向かう\nその旅の途中で降りてきた\n\n「レムリア」に関わる\n重要なメッセージを\n\nリアルタイムでお届けする\n特別な時間です。\n\nこのメッセージは\nあらかじめ用意されたものではなく\n\nその場で降りてくるエネルギーを\nそのままお届けするものです。`}
          </p>
        </section>

        {/* ── セクション③ LINE登録の理由 ── */}
        <section className="text-center mb-14 w-full">
          <h2 className="text-base font-semibold mb-6 leading-relaxed" style={{ color: '#2c2416', letterSpacing: '0.12em' }}>
            なぜLINE登録が必要なのか？
          </h2>
          <p className="text-sm leading-[2.2]" style={{ color: '#5a4a35', letterSpacing: '0.06em' }}>
            今回のシークレットLIVEは<br />
            特別な内容のため<br /><br />
            参加URLは限定配布となっており<br /><br />
            LINEにご登録いただいた方へ<br />
            <strong>直接</strong>お送りしています。
          </p>
        </section>

        {/* ── セクション④ ベネフィット ── */}
        <section className="w-full mb-14">
          <h2 className="text-base font-semibold text-center mb-7" style={{ color: '#2c2416', letterSpacing: '0.12em' }}>
            LINE登録で受け取れる内容
          </h2>
          <div className="flex flex-col gap-3">
            {['ZOOM参加URL', '当日のリマインド通知', '最新の重要メッセージ'].map((item, i) => (
              <div key={i} className="flex items-center gap-4 rounded-xl px-5 py-4" style={{
                background: 'linear-gradient(135deg, rgba(212,175,55,0.06), rgba(212,175,55,0.02))',
                border: '1px solid rgba(212,175,55,0.25)',
              }}>
                <div className="w-7 h-7 flex items-center justify-center flex-shrink-0" style={{ color: '#d4af37', fontSize: '14px' }}>✦</div>
                <span className="text-sm" style={{ color: '#3d2e1a', letterSpacing: '0.07em' }}>{item}</span>
              </div>
            ))}
          </div>
          <p className="text-xs text-center mt-4" style={{ color: '#b8963e', letterSpacing: '0.08em' }}>※見逃し防止のため必須です</p>
        </section>

        {/* ── セクション⑤ CTA ── */}
        <section className="w-full mb-14">
          <p className="text-sm text-center font-semibold mb-5 tracking-widest" style={{ color: '#2c2416', letterSpacing: '0.15em' }}>
            今すぐ受け取る
          </p>
          <a
            href={LINE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="w-full flex items-center justify-center gap-3 py-5 rounded-2xl font-bold text-base cursor-pointer whitespace-nowrap transition-all active:scale-95"
            style={{
              background: 'linear-gradient(135deg, #06C755 0%, #00a846 100%)',
              color: '#ffffff',
              letterSpacing: '0.1em',
              fontSize: '16px',
              boxShadow: '0 6px 30px rgba(6,199,85,0.3)',
              textDecoration: 'none',
            }}
          >
            <i className="ri-line-fill text-2xl" />
            LINEで参加URLを受け取る
          </a>
          <div className="flex flex-col items-center gap-1 mt-4">
            <p className="text-xs" style={{ color: '#9a8060', letterSpacing: '0.08em' }}>※30秒で登録完了します</p>
            <p className="text-xs font-semibold" style={{ color: '#c0392b', letterSpacing: '0.08em' }}>※LINE登録しないと参加できません</p>
          </div>
        </section>

        {/* ── セクション⑥ 最後の訴求 ── */}
        <section className="text-center mb-14 w-full">
          <p className="text-sm leading-[2.4] whitespace-pre-line" style={{ color: '#4a3a28', letterSpacing: '0.07em' }}>
            {`今回のLIVEは\n内容を事前にすべて\nお伝えすることはできません。\nなぜなら\nその場で降りてくるメッセージを\nそのままお届けするからです。`}
          </p>
          <div className="my-8 rounded-xl px-6 py-6" style={{
            background: 'linear-gradient(135deg, rgba(212,175,55,0.07), rgba(212,175,55,0.03))',
            border: '1px solid rgba(212,175,55,0.25)',
          }}>
            <p className="text-sm leading-loose italic" style={{ color: '#3d2e1a', letterSpacing: '0.08em' }}>
              「今このタイミングで<br />
              受け取る人がいる」
            </p>
          </div>
          <p className="text-sm leading-[2.4] whitespace-pre-line" style={{ color: '#4a3a28', letterSpacing: '0.07em' }}>
            {`もしあなたの魂が\n「レムリア」という言葉に\n少しでも反応しているなら\n\nこの時間は\nきっと意味のあるものになるでしょう。`}
          </p>
        </section>

        {/* ── セクション⑦ 開催概要 ── */}
        <section className="w-full mb-14">
          <div className="rounded-2xl px-8 py-8 text-center" style={{
            background: 'linear-gradient(160deg, #2c2416, #3d3020)',
            border: '1px solid rgba(212,175,55,0.4)',
          }}>
            <p className="text-xs tracking-widest mb-4" style={{ color: '#d4af37', letterSpacing: '0.25em' }}>EVENT</p>
            <h2 className="text-base font-semibold mb-6 leading-relaxed" style={{ color: '#f5e8c0', letterSpacing: '0.12em' }}>
              【緊急シークレットLIVE】
            </h2>
            <div className="w-12 h-px mx-auto mb-6" style={{ background: 'rgba(212,175,55,0.4)' }} />
            <p className="text-sm leading-[2.2]" style={{ color: '#e8d89a', letterSpacing: '0.1em' }}>
              3月23日（月）<br />
              <span className="text-xl font-bold" style={{ color: '#d4af37' }}>21:00〜</span><br /><br />
              フランスから<br />
              リアルタイムでお届けします
            </p>
          </div>
        </section>

        {/* ── 2回目CTA ── */}
        <section className="w-full mb-14">
          <a
            href={LINE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="w-full flex items-center justify-center gap-3 py-5 rounded-2xl font-bold text-base cursor-pointer whitespace-nowrap transition-all active:scale-95"
            style={{
              background: 'linear-gradient(135deg, #06C755 0%, #00a846 100%)',
              color: '#ffffff',
              letterSpacing: '0.1em',
              fontSize: '16px',
              boxShadow: '0 6px 30px rgba(6,199,85,0.3)',
              textDecoration: 'none',
            }}
          >
            <i className="ri-line-fill text-2xl" />
            LINEで参加URLを受け取る
          </a>
          <div className="flex flex-col items-center gap-1 mt-4">
            <p className="text-xs" style={{ color: '#9a8060', letterSpacing: '0.08em' }}>※30秒で登録完了します</p>
            <p className="text-xs font-semibold" style={{ color: '#c0392b', letterSpacing: '0.08em' }}>※LINE登録しないと参加できません</p>
          </div>
        </section>

        {/* ── セクション⑧ 締め ── */}
        <section className="text-center mb-16 w-full">
          <p className="text-sm leading-[2.4]" style={{ color: '#4a3a28', letterSpacing: '0.08em' }}>
            当日、あなたと<br />
            この特別な時間をご一緒できますことを<br />
            心より楽しみにしています。
          </p>
          <div className="mt-10 flex flex-col items-center gap-2">
            <div className="w-6 h-px" style={{ background: 'rgba(212,175,55,0.5)' }} />
            <p className="text-sm" style={{ color: '#9a8060', letterSpacing: '0.12em' }}>愛と感謝をこめて</p>
            <p className="text-base font-semibold mt-1" style={{ color: '#2c2416', letterSpacing: '0.2em' }}>穴口恵子</p>
          </div>
        </section>

      </div>

      {/* ── フッター細線 ── */}
      <div className="w-full h-px" style={{ background: 'linear-gradient(90deg, transparent, rgba(212,175,55,0.5), transparent)' }} />

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,400;0,600;1,400;1,600&family=Noto+Serif+JP:wght@400;500;600;700&display=swap');
        @keyframes starTwinkle {
          0%, 100% { opacity: 0.1; transform: scale(1); }
          50% { opacity: 0.9; transform: scale(1.6); }
        }
      `}</style>
    </div>
  );
}
